import { Transition, Variants } from "framer-motion";

const transition: Transition = { duration: 0.3, ease: "circIn" };

export const getCircleVariants = (index: number): Variants => {
  return {
    hidden: {
      width: 0,
      height: 0,
      opacity: 0,
      transition,
    },
    visible: {
      width: `calc(25vw + ${index * 5}rem)`,
      height: `calc(25vw + ${index * 5}rem)`,
      opacity: 1 / index,
      transform: "translate(-50%, -50%)",
      transition: {
        ...transition,
        delay: index * 0.3,
      },
    },
  };
};
